export default __webpack_public_path__ + "static/media/check.ab94b1a8.svg";